import React, { ReactNode, createContext, useContext } from 'react'
import { settingsStore } from '@/stores/settingsStore'
import { userStore } from '@/stores/userStore'
import { chatHistoryStore } from '@/stores/chatHistoryStore'
import { chatStore } from '@/stores/mobxChatStore'
import { consentStore } from '@/stores/consentStore'

// Create a context for stores
export interface RootStore {
  settingsStore: typeof settingsStore
  userStore: typeof userStore
  chatHistoryStore: typeof chatHistoryStore
  chatStore: typeof chatStore
  consentStore: typeof consentStore
}

const rootStore: RootStore = {
  settingsStore,
  userStore,
  chatHistoryStore,
  chatStore,
  consentStore,
}

const StoreContext = createContext<RootStore | null>(null)

// Custom hook for using the stores
export const useStores = (): RootStore => {
  const context = useContext(StoreContext)
  if (!context) {
    throw new Error('useStores must be used within a StoreProvider')
  }
  return context
}

// Provider component that makes the stores available to all child components
const StoreProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>
}

export default StoreProvider
